var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#refresh-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    d: "M14.33.042a.29.29 0 0 0-.318.062L12.238 1.86A6.93 6.93 0 0 0 7.5 0a7 7 0 1 0 5.6 11.2 1.166 1.166 0 1 0-1.867-1.4A4.666 4.666 0 1 1 7.5 2.333 4.6 4.6 0 0 1 10.575 3.5L8.598 5.461a.293.293 0 0 0 .023.435.3.3 0 0 0 .15.061l5.414.6h.033a.29.29 0 0 0 .291-.292V.312a.29.29 0 0 0-.18-.27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "refresh-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h14v14H.5z"
  })))));
};
export default SvgRefreshIcon;